<template>
  <div>
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @timeupdate="onPlayerTimeupdate($event)"
      @ready="playerReadied"
    >
    </video-player>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  name: "videoPlaying",
  components: {
    videoPlayer
  },
  props: ["videoURL", "visible"],
  data() {
    return {
      playerOptions: {}
    };
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player; //自定义播放
    }
  },
  watch: {
    videoURL: "createOption",
    visible: "pauseVideo"
  },
  created() {
    this.createOption();
  },
  methods: {
    //创建playerOptions
    createOption() {
      const url = this.$props.videoURL;
      this.playerOptions = {
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        language: "zh-CN",
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        sources: [
          {
            type: "video/mp4", // 类型
            src: url //视频地址
          }
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      };
    },
    //关闭后暂停视频
    pauseVideo(val) {
      if (!val) {
        this.player.pause();
      }
    },
    // listen event
    //视频的时间改变就触发
    onPlayerTimeupdate() {
      // console.log("player Timeupdate!", player.currentTime());
    },
    // player is ready
    playerReadied(player) {
      // console.log("example player 1 readied", player);
      player.currentTime(0);
    }
  }
};
</script>

<style></style>
